<template>
  <div class="navbar">
    <h1 class="logo-box"><span class="logo logo--white">{{title}}</span></h1>

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item"/>

        <error-log class="errLog-container right-menu-item hover-effect"/>

        <screenfull id="screenfull" class="right-menu-item hover-effect"/>

        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect"/>
        </el-tooltip>

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <img :src="userAvatar" class="user-avatar">
          <span>{{ $store.getters.name }}</span>
          <i class="el-icon-caret-bottom"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">安全退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import defaultSettings from '@/settings'
import ErrorLog from './ErrorLog'
import Screenfull from './Screenfull'
import SizeSelect from './SizeSelect'
import Search from './HeaderSearch'
import userAvatar from '@/assets/img/user_avatar.png'

export default {
  components: {
    Breadcrumb,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
  },
  data () {
    return {
      title: defaultSettings.title,
      userAvatar,
    }
  },
  computed: {
    ...mapGetters([
      'avatar',
      'device',
    ]),
  },
  methods: {
    async logout () {
      await this.$store.dispatch('FedLogOut')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
  },
}
</script>
